import { BrandBgEntityRaw, BrandBgIsInUse } from "@common/domain";
import { EntityState, EntityAdapter, createEntityAdapter } from "@ngrx/entity";
import { createReducer, on, Action } from "@ngrx/store";
import { flatMap } from "lodash";
import { BrandBgActions, BrandActions } from "../actions";

export const BRAND_BG_FEATURE_KEY = "brandBg";

export interface BrandBgState extends EntityState<BrandBgEntityRaw> {}

export const brandBgAdapter: EntityAdapter<BrandBgEntityRaw> =
  createEntityAdapter<BrandBgEntityRaw>({
    selectId: (_) => _.id,
    sortComparer: (lhs, rhs) => {
      if (lhs.isDefault && rhs.isDefault) {
        return lhs.id - rhs.id;
      }

      if (lhs.isDefault) {
        return -1;
      }

      if (rhs.isDefault) {
        return 1;
      }

      return lhs.id - rhs.id;
    }
  });

export const initialBrandBgState: BrandBgState = brandBgAdapter.getInitialState(
  {}
);

const reducer = createReducer(
  initialBrandBgState,
  on(BrandActions.brandGetListSuccess, (state, { brands }) =>
    brandBgAdapter.addMany(
      flatMap(brands, (_) => _.value.bgs),
      state
    )
  ),
  on(BrandActions.brandCreateSuccess, (state, { brand }) => {
    return brandBgAdapter.addMany(brand.value.bgs, state);
  }),
  on(BrandActions.brandDeleteSuccess, (state, { brandId }) => {
    const bgs = Object.values(state.entities).filter(
      (_) => _?.brandId === brandId
    );

    return brandBgAdapter.removeMany(
      bgs.map((_) => _!.id),
      state
    );
  }),
  on(BrandBgActions.brandBgCreateSuccess, (state, { brandBg }) =>
    brandBgAdapter.addOne(brandBg.toJSON(), state)
  ),
  on(BrandBgActions.brandBgDeleteSuccess, (state, { brandBg }) =>
    brandBgAdapter.removeOne(brandBg.value.id, state)
  ),
  on(BrandBgActions.brandBgUnUseSuccess, (state, { brandBg }) =>
    brandBgAdapter.updateOne(
      {
        id: brandBg.value.id,
        changes: { isInUse: false as BrandBgIsInUse }
      },
      state
    )
  ),
  on(BrandBgActions.brandBgUseSuccess, (state, { brandBg }) => {
    const bgs = Object.values(state.entities).filter(
      (_) => _?.brandId === brandBg.value.brandId
    );

    return brandBgAdapter.updateOne(
      {
        id: brandBg.value.id,
        changes: { isInUse: true as BrandBgIsInUse }
      },
      brandBgAdapter.updateMany(
        bgs.map((_) => ({
          id: _!.id,
          changes: { isInUse: false as BrandBgIsInUse }
        })),
        state
      )
    );
  })
);

export function brandBgReducer(
  state: BrandBgState | undefined,
  action: Action
) {
  return reducer(state, action);
}
